import React, { useState } from "react";
import NxtbnDrawer from "../../drawer";
import useApi from "../../../api";
import { InputField, NXForm } from "../../common";
import { toast } from "react-toastify";
import { gql, useMutation } from '@apollo/client';
import NxtbnModal from "../../Modal";

interface ChangePasswordFormProps {
  userId: string;
  isOpen: boolean;
  onClose: () => void;
}

const USER_PASSWORD_CHANGE_MUTATION = gql`
  mutation ChangeUserPassword($userId: ID!, $password: String!, $confirmPassword: String!) {
    changeUserPassword(userId: $userId, password: $password, confirmPassword: $confirmPassword) {
      message
      success
    }
  }
`;

function UserChangePasswordForm({ userId, isOpen, onClose }: ChangePasswordFormProps) {
  const api = useApi();
  const [formData, setFormData] = useState({
    password: "",
    confirm_password: "",
  });
  const [errorData, setErrorData] = useState<any>();


  const [changeUserPassword, { loading, error }] = useMutation(USER_PASSWORD_CHANGE_MUTATION);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();

    if (formData.password !== formData.confirm_password) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const { data } = await changeUserPassword({
        variables: {
          userId,
          password: formData.password,
          confirmPassword: formData.confirm_password,
        },
      });

      if (data.changeUserPassword.success) {
        toast.success("Password updated successfully.");
        onClose(); // Close the modal after successful password change
      } else {
        toast.error(data.changeUserPassword.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("Error changing password.");
      console.error(err);
    }
  };

  return (
    <NxtbnModal size="sm" isOpen={isOpen} onClose={onClose}>
      <NXForm className="p-4" onSubmit={onSubmit} title="Update Password" nonFieldError={{}}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">New Password</label>
          <InputField
            type="password"
            name="password"
            placeholder="Enter new password"
            value={formData.password}
            onChange={handleInputChange}
            required
            className="mt-1 w-full p-2 border rounded"
            errorData={errorData}
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Confirm Password</label>
          <InputField
            type="password"
            name="confirm_password"
            placeholder="Confirm new password"
            value={formData.confirm_password}
            onChange={handleInputChange}
            required
            className="mt-1 w-full p-2 border rounded"
            errorData={errorData}
          />
        </div>

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="px-4 py-2 text-white bg-[#0CAF60] hover:bg-[#098d4d] disabled:bg-[#0caf609a] text-sm font-medium rounded-md shadow-sm"
            disabled={loading}
          >
            {loading ? "Changing..." : "Change Password"}
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  );
}

export default UserChangePasswordForm;
